import React, { FC, PropsWithChildren } from 'react';

import { useSelector } from 'react-redux';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { StateType } from '~/redux/types';

import { useValidGameCenterRoute } from '../../hooks';
import { LoadingContainer, LOADING_DISPLAY_SIZE } from '../../styles';

type Props = {
    isInitialLoad: boolean;
};

// When no game is present in redux we show a full screen loader since nothing has been fetched, and we know nothing
// about the game. When a game is present, but the section we're on is initially loading we show an inline loader since
// the tab is being switched.
const GameCenterLoader: FC<PropsWithChildren<Props>> = ({ children, isInitialLoad }) => {
    const gameState = useSelector((state: StateType) => state.gameCenter?.gameState);
    const isValidRoute = useValidGameCenterRoute();

    if (!gameState || !isValidRoute) {
        return <LoadingDisplay isLoading />;
    } else if (isInitialLoad) {
        return (
            <LoadingContainer>
                <LoadingDisplay isInline isLoading size={LOADING_DISPLAY_SIZE} />
            </LoadingContainer>
        );
    }

    return children;
};

export default GameCenterLoader;
